import { setSelectedNoteColor } from '../mutators/setSelectedNoteColor';
import { setSelectedNoteId } from '../mutators/setSelectedNoteId';
import LayoutSdk, { IWarningDialogOptions } from '@notes/sticky-notes-layout';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { getDefaultAnchorMailboxCookie } from 'owa-ows-gateway/lib/anchormailbox';
import { getUserConfiguration } from 'owa-session-store';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { getGuid } from 'owa-guid';
import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';

import { logUnsampledNotesDataPoint } from './logNotesTelemetryEvent';

async function getTokenForNotes(correlationId: string): Promise<string> {
    logUnsampledNotesDataPoint('Notes_GetAccessTokenStart', {
        correlationId,
    });
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(window.location.origin);
    // If token is not returned synchronously, we need to await on the tokenPromise
    if (!token) {
        token = await tokenPromise;
    }
    return token;
}

function authNotesSDK() {
    const correlationId = getGuid();
    getTokenForNotes(correlationId).then(token => {
        const customData = { success: false, correlationId };
        if (token) {
            customData.success = true;
        }
        logUnsampledNotesDataPoint('Notes_GetAccessTokenEnd', customData);
        const defaultAnchorMailbox = getDefaultAnchorMailboxCookie();
        notesSdk.setAADAccessToken(token, defaultAnchorMailbox, 'OWA');
    });
}

function updateSelectedNoteIdAndColor() {
    const noteId = notesSdk.stores.layoutSDKStore.getState().currentNoteId;
    const noteColor = notesSdk.stores.layoutSDKStore.getState().notesCollection.getNote(noteId)
        .color;
    setSelectedNoteId(noteId);
    setSelectedNoteColor(noteColor);
}

async function onWarningDialog(options: IWarningDialogOptions) {
    const { titleString, dialogString, confirmString, cancelString, resolve, reject } = options;
    const response = await confirm(titleString, dialogString, false, {
        okText: confirmString,
        cancelText: cancelString,
    });

    if (response === DialogResponse.ok && resolve) {
        resolve();
    }

    if (response === DialogResponse.cancel && reject) {
        reject();
    }
}

var notesSdk: LayoutSdk = null;
export default function getNotesSDK(): LayoutSdk {
    if (notesSdk == null) {
        notesSdk = new LayoutSdk({
            appName: 'OWA',
            appVersion: '0.1',
            showAppHeader: true,
            storage: false,
            sync: true,
            onNotesUpdated: updateSelectedNoteIdAndColor,
            onSelectedNoteIdChanged: updateSelectedNoteIdAndColor,
            onUnauthorized: () => {
                authNotesSDK();
            },
            onWarningDialog: onWarningDialog,
            uniqueUserId: getDefaultAnchorMailboxCookie(),
            darkMode: getIsDarkTheme(),
        });
        notesSdk.ready.then(() => {
            authNotesSDK();
            notesSdk.changeLanguage(getUserConfiguration().SessionSettings.UserCulture);
        });
    }
    return notesSdk;
}
